<template>
  <v-container fluid style="height: 100vh">
    <v-menu z-index="4000" open-on-hover>
      <template v-slot:activator="{ on: menu, attrs }">
        <v-btn
          fab
          top
          left
          x-small
          fixed
          color="orange"
          elevation="2"
          v-bind="attrs"
          v-on="{ ...menu }"
        >
                <span
                  style="font-weight: bold; font-size: 25px; color: white; -webkit-text-stroke: 1px #ffc979">S</span>
        </v-btn>
      </template>

      <v-card>
        <MainMenu />
      </v-card>
    </v-menu>

    <v-tooltip bottom open-delay="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          top
          left
          x-small
          fixed
          style="top: 58px;border-color: #adadad"
          elevation="2"
          outlined
          ref="largeButton"
          v-bind="attrs"
          v-on="on"
          v-on:click="onLarge"
        >
          <v-icon v-if="large" style="padding-top: 1px">zoom_in_map</v-icon>
          <v-icon v-else style="padding-top: 1px">zoom_out_map</v-icon>
        </v-btn>
      </template>
      <span v-if="large">{{ $t("map-preview.size2small") }}</span>
      <span v-else>{{ $t("map-preview.size2large") }}</span>
    </v-tooltip>


    <v-tooltip bottom open-delay="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          top
          left
          x-small
          fixed
          style="top: 102px;border-color: #adadad"
          elevation="2"
          :outlined="!rowLimit"
          :color="(rowLimit) ? '#BBDEFB' : 'default'"
          ref="rowLimitButton"
          v-bind="attrs"
          v-on="on"
          v-on:click="onRowLimit"
        >
          <v-icon style="padding-top: 1px">vertical_align_bottom</v-icon>
        </v-btn>
      </template>
      <span v-if="rowLimit">{{ $t("map-preview.rowall") }}</span>
      <span v-else>{{ $t("map-preview.row10") }}</span>
    </v-tooltip>

    <v-layout fill-height align-start>
      <v-row class="overflow-y-auto " style="max-height: 100%; padding: 0px 60px">
        <v-flex d-flex>
          <v-layout wrap>
            <v-flex v-for="item in vehicles" :key="item.vehicleId"
                    :style="{'width': ((large) ? 410 : 310) + 'px', margin: '10px 5px' }"
                    shrink>
              <VehiclePreview :vehicle="item" :large="large" />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>

import VehiclePreview from "@/components/map/VehiclePreview.vue";
import MainMenu from "@/components/MainMenu.vue";
import Vue from "vue";

export default {
  name: "MapPreviewView",

  components: {
    MainMenu,
    VehiclePreview
  },

  data() {
    return {
      large: false,
      rowLimit: true,
      count: 40
    };
  },

  methods: {
    onLarge() {
      this.$refs.largeButton.$el.blur();
      this.large = !this.large;
      this.countRecalc();

      Vue.$cookies.set("preview-map-large", this.large, "14d");
    },

    onRowLimit() {
      this.$refs.rowLimitButton.$el.blur();
      this.rowLimit = !this.rowLimit;

      Vue.$cookies.set("preview-map-rowlimit", this.rowLimit, "14d");
    },

    countRecalc() {
      this.count = Math.floor((window.innerWidth - 120) / ((this.large ? 420 : 320))) * 10;
    }
  },

  computed: {
    vehicles() {
      if (this.rowLimit)
        return this.$store.state.online.visibleVehicles
          .filter(v => v.location !== null)
          .slice(0, this.count);
      else
        return this.$store.state.online.visibleVehicles
          .filter(v => v.location !== null);
    }
  },

  created() {
    window.addEventListener("resize", this.countRecalc);
  },

  destroyed() {
    window.removeEventListener("resize", this.countRecalc);
  },

  mounted() {
    let valueLarge = Vue.$cookies.get("preview-map-large");
    this.large = valueLarge !== undefined && valueLarge !== null && valueLarge === "true";

    let valueRowLimit = Vue.$cookies.get("preview-map-rowlimit");
    this.rowLimit = valueRowLimit === undefined || valueRowLimit === null || valueRowLimit === "true";

    this.countRecalc();
  }
};
</script>

<style scoped lang="sass">
</style>